"use strict";

define('controller/base',['require','exports','module','appkit/region.controller','marionette'],function (require, exports, module) {
  var RegionController = require('appkit/region.controller');
  var Mn = require('marionette');
  var BaseController = RegionController.extend({
    authorities: [],
    features: [],
    fallbackFragment: 'dashboard',
    constructor: function constructor() {
      RegionController.apply(this, arguments);
      this.once('before:start', this._baseOnBeforeStart, this);
    },
    navigateFallback: function navigateFallback() {
      var fragment = Mn._getValue(this.fallbackFragment, this);
      if (fragment != null) {
        this.app.navigate(fragment, {
          trigger: true
        });
      }
    },
    onPageError: function onPageError() {
      this.navigateFallback();
    },
    _baseOnBeforeStart: function _baseOnBeforeStart() {
      this._updateTitle();
      if (!this._checkAuthority()) {
        throw new Error('You have insufficient permissions to access this page.');
      }
      if (!this._checkFeature()) {
        throw new Error('You do not have the necessary features to access this page.');
      }
    },
    _updateTitle: function _updateTitle() {
      var title = Mn._getValue(this.header, this);
      if (title != null) {
        this.app.title = title;
      }
    },
    _checkAuthority: function _checkAuthority() {
      return this.request('check:authority', _.result(this, 'authorities'));
    },
    _checkFeature: function _checkFeature() {
      return this.request('check:feature', this.features);
    },
    addDimmerToRequest: function addDimmerToRequest(model) {
      var app = this.app;
      this.listenTo(model, 'request', function (model, xhr, options) {
        xhr.promise()["finally"](app.request('dimmer'));
      });
    },
    userHasPermission: function userHasPermission(perm) {
      return this.app.user.person.hasPermission(perm);
    }
  });
  module.exports = BaseController;
});

